<template>
  <div>
    <f7-block class="no-margin padding bg-lightsnow">
      <UCSearchEntityERP
        v-if="defaultSelectedWorker === null"
        ref="UCWorkersComponent"
        :title="$t('searchEntity.worker.title.searchWorkerForNewRecord')"
        :placeholder="$t('searchEntity.worker.placeholder.numberNameFirstLastName')"
        :search-text="$t('searchEntity.worker.searchText')"
        :search-cancellation-text="$t('searchEntity.worker.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.worker.searchNotFoundText')"
        :end-point-for-code-search="GetWorkerCodeSearch"
        :end-point-for-list="GetWorkerList"
        :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :min-text-search="1"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventselectedWorker"
      />
      <div v-if="selectedWorker != null">
        <!-- Datos Trabajador Seleccionado -->
        <div class="div-cabeceraDatosTrabajador">
          <PCWorkerPresenceCard
            v-if="selectedWorker != null"
            :selected-worker="selectedWorker"
          />
        </div>
      </div>
      <div v-if="selectedWorker != null">
        <UCSearchEntityERP
          ref="UCProductionLineComponent"
          :title="$t('searchEntity.line.title.selectProductionLineForNewRecord')"
          :placeholder="$t('searchEntity.line.placeholder.codeLine')"
          :search-text="$t('searchEntity.line.searchText')"
          :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
          :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
          :end-point-for-code-search="ProductionLineCodeSearch"
          :end-point-for-list="ProductionLineList"
          :property-entity-shown-input="['Codigo', 'Nombre']"
          :property-entity-shown-list-title="['Codigo']"
          :property-entity-shown-list-subtitle="['Nombre']"
          :default-value="defaultSelectedLine"
          class="padding-bottom-half"
          :emit-evet-change-default-value="true"
          :disabled="selectedActivity != null && !IsProductionActivity(selectedActivity)"
          @selection="EventSelectedProductionLine"
        />
        <!-- :disabled="!(selectedActivity !=null && IsProductionActivity(selectedActivity))" -->
      </div>
      <div
        v-if="selectedWorker != null"
      >
        <UCSearchEntityERP
          ref="UCActivityComponent"
          :title="$t('searchEntity.productionActivity.title.chooseProductionActivityForNewRecord')"
          :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
          :search-text="$t('searchEntity.productionActivity.searchText')"
          :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
          :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
          :end-point-for-code-search="ActivityCodeSearch"
          :end-point-for-list="ActivityList"
          :property-entity-shown-input="['Codigo', 'Nombre']"
          :property-entity-shown-list-title="['Codigo']"
          :property-entity-shown-list-subtitle="['Nombre']"
          class="padding-bottom-half"
          @selection="EventSelectedProductionActivity"
        />
      </div>
      <div
        v-if="selectedWorker != null"
        class="content-titulo-select no-margin padding-bottom-half"
      >
        <UCDatePicker
          ref="UCDateNewRecord"
          title="Fecha de marcaje"
          :min-date="GetMinDateRecord()"
          :max-date="GetMaxDateRecord()"
          @onchange="DateChanged"
        />
        <UCTimePicker
          :show-input="false"
          :template="template"
          :title="template === 'P2' ? 'Hora Marcaje' : ''"
          :show-seconds="secondsOnTimePicker"
          @onchange="TimeChanged"
        />
      </div>

      <div v-if="selectedWorker != null">
        <!-- Botones de  confirmar/cancelar -->
        <f7-row>
          <f7-col width="50">
            <f7-button
              fill
              class="button button-fill color-gray"
              @click="CancelOperation()"
            >
              {{ $t('common.cancel') }}
            </f7-button>
          </f7-col>
          <f7-col width="50">
            <f7-button
              fill
              class="button button-fill color-green"
              @click="ConfirmOperation()"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </f7-col>
        </f7-row>
      </div>
    </f7-block>
    <!-- <pre>{{ defaultSelectedWorker }}</pre> -->
  </div>
</template>

<script>
import { useParamRef } from '@erpagroapp/params';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import PCWorkerPresenceCard from '@/components/presence/workerRecords/PCWorkerPresenceCard.vue';
import APIErp from '@/js/services/APIErp';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import { sleep } from '@/js/utils/sleep';

/** @import { MarcajeCerco } from '@erpagroapp/types' */

export default {
  name: 'PCNewWorkerRecord',
  components: {
    UCSearchEntityERP,
    PCWorkerPresenceCard,
    UCTimePicker,
    UCDatePicker,
  },
  props: {
    defaultSelectedWorker: { type: Object, default: null },
    defaultSelectedLine: { type: Object, default: null },
    template: { type: String, default: 'P1' },
    resetWhenGeneratingNewRecord: { type: Boolean, default: false },
    restrictDayMarking: { type: Boolean, default: false }, /** Solo permite hacer marcajes de la jornada en curso */
    secondsOnTimePicker: { type: Boolean, default: false },
  },

  emits: [
    'on-cancel',
    'on-success',
  ],

  data() {
    return {
      dateTimeNewRecord: Date.now(),
      dateNewRecord: Date.now(),
      timeNewRecord: '00:00',
      selectedActivity: null,
      selectedWorker: null,
      selectedProductionLine: null,
      noPermitirModificarMarcajePresencia: useParamRef('NoPermitirModificarMarcajePresencia'),
    };
  },
  watch: {
    defaultSelectedWorker(val) {
      this.selectedWorker = val;
    },
    defaultSelectedLine(val) {
      this.selectedProductionLine = val;
      // if (val != null) { this.EventSelectedProductionLine(val); }
    },
    async selectedWorker() {
      await sleep(200);
      this.ResetComponent();
    },
  },
  mounted() {
    this.StartForm();
  },

  methods: {

    StartForm() {
      Log(this, this.StartForm.name);
      if (this.defaultSelectedWorker != null) {
        this.selectedWorker = this.defaultSelectedWorker;
        if (this.defaultSelectedLine != null) {
          this.selectedProductionLine = this.defaultSelectedLine;
          this.EventSelectedProductionLine(this.selectedProductionLine);
        }
      }
    },

    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      if (this.selectedProductionLine != null) {
        return APIErp.callProductionActivityListXLineAuthorized(this.selectedProductionLine.Id);
      }
      return APIErp.callProductionActivityListAuthorized();
    },
    ProductionLineCodeSearch(params) {
      Log(this, this.ProductionLineCodeSearch.name);
      return APIErp.callProductionLineSearchCode(params);
    },
    ProductionLineList() {
      Log(this, this.ProductionLineList.name);
      if (this.selectedActivity != null) {
        return APIErp.callLinesListXActivity(this.selectedActivity.Id);
      }
      return APIErp.callProductionLineListAuthorized();
    },
    async EventSelectedProductionActivity(objActivity) {
      Log(this, this.EventSelectedProductionActivity.name);
      this.selectedActivity = objActivity;
      if (this.selectedActivity != null) {
        if (!this.IsProductionActivity(this.selectedActivity)) {
          this.$refs.UCProductionLineComponent.Clear();
        } else {
          HiDialog.Preloader(true);
          const result = await this.ProductionLineList();
          if (result != null && result.status === 200 && result.data.length === 1) {
            this.$refs.UCProductionLineComponent
              .SelectEntity(result.data[0], false);
            [this.selectedProductionLine] = result.data;
          }
          HiDialog.Preloader(false);
        }
      }
    },
    async EventSelectedProductionLine(objLine) {
      Log(this, this.EventSelectedProductionLine.name);
      this.selectedProductionLine = objLine;
      if (this.selectedProductionLine != null) {
        HiDialog.Preloader(true);
        const result = await this.ActivityList();
        if (result != null && result.status === 200 && result.data.length === 1) {
          this.$refs.UCActivityComponent.SelectEntity(result.data[0], false);
          [this.selectedActivity] = result.data;
        }
        HiDialog.Preloader(false);
      } else if (this.selectedActivity != null && this.IsProductionActivity(this.selectedActivity)) {
        this.$refs.UCActivityComponent.Clear({ autoFocus: false });
      }
    },
    async EventselectedWorker(objWorker) {
      Log(this, this.EventselectedWorker.name);
      this.selectedWorker = objWorker;
      if (objWorker != null && this.defaultSelectedLine != null) {
        await sleep(100);
        this.EventSelectedProductionLine(this.defaultSelectedLine);
      }
    },
    GetWorkerCodeSearch(params) {
      Log(this, this.GetWorkerCodeSearch.name);
      return APIErp.callWorkerSearchText(params);
    },
    GetWorkerList() {
      Log(this, this.GetWorkerList.name);
      return APIErp.callWorkerList();
    },
    TimeChanged(value) {
      Log(this, this.TimeChanged.name);
      this.timeNewRecord = value;
      this.dateTimeNewRecord = `${HiDateTimeSupport.FormatDateTime(this.dateNewRecord, 'YYYY-MM-DD')} ${value}`;
    },
    DateChanged(value) {
      Log(this, this.DateChanged.name);
      this.dateNewRecord = `${HiDateTimeSupport.FormatDateTime(value, 'YYYY-MM-DD')}`;
      this.dateTimeNewRecord = `${this.dateNewRecord}  ${this.timeNewRecord}`;
    },
    CancelOperation() {
      Log(this, this.CancelOperation.name);
      this.$emit('on-cancel');
    },
    ConfirmOperation() {
      Log(this, this.ConfirmOperation.name);
      if (this.selectedActivity == null) {
        HiNotification.Alert('Es necesario seleccionar una actividad de producción para realizar el marcaje.', 'Seleccione actividad');
        return;
      }
      if (this.selectedWorker == null) {
        HiNotification.Alert('Es necesario seleccionar un trabajador para realizar el marcaje.', 'Seleccione trabajador');
        return;
      }
      if (this.dateTimeNewRecord == null) {
        HiNotification.Alert('Es necesario seleccionar la hora de realización del marcaje.', 'Seleccione la hora');
        return;
      }
      if (this.selectedProductionLine == null && this.IsProductionActivity(this.selectedActivity)) {
        HiNotification.Alert('Es necesario seleccionar una línea de producción para realizar el marcaje.', 'Seleccione línea');
        return;
      }
      if (this.selectedActivity != null && this.selectedActivity.Codigo === 'NOA') {
        HiNotification.Alert('No es posible realizar marcajes en esta actividad', 'Actividad no valida');
        return;
      }
      if (this.noPermitirModificarMarcajePresencia && this.selectedActivity.Codigo === 'PRE') {
        HiNotification.Alert('No es posible realizar marcajes en esta actividad', 'Actividad no valida');
        return;
      }
      // Si las validaciones previas son correctas realizamos el marcaje.
      /** @type {PartialDeep<MarcajeCerco>} */
      const objMarcaje = {
        Id: 0,
        Trabajador: this.selectedWorker,
        LineaProduccion: this.selectedProductionLine,
        ActividadProduccion: this.selectedActivity,
        FechaHora: HiDateTimeSupport.FormatDateTime(this.dateTimeNewRecord, ''),
      };
      this.Conection_MakeNewRecordWorker(objMarcaje);
    },
    IsProductionActivity(objActivity) {
      Log(this, this.IsProductionActivity.name);
      if (objActivity === null || objActivity === undefined) {
        return false;
      }
      if (objActivity.Codigo === 'PRE') {
        return false;
      }
      if (objActivity.Codigo === 'ASE') {
        return false;
      }
      return true;
    },
    ResetComponent() {
      this.$refs.UCDateNewRecord.initialize();
    },
    GetMaxDateRecord() {
      if (this.restrictDayMarking) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), 24, 0);
      }
      return new Date(8640000000000000);
    },
    GetMinDateRecord() {
      if (this.restrictDayMarking) {
        return HiDateTimeSupport.AddHoursAndMinutes(new Date(), -48, 0);
      }
      return new Date(-8640000000000000);
    },

    Conection_MakeNewRecordWorker(objMarcaje) {
      Log(this, this.Conection_MakeNewRecordWorker.name);
      const self = this;
      HiDialog.Preloader(true, 'Guardando marcaje');
      APIErp.callMakeNewRecordsWorkers([objMarcaje])
        .then((result) => {
          if (result.data.valor) {
            HiNotification.Toast('Marcaje realizado correctamente.');
            eventBus.emit('new-record-done');
            self.$emit('on-success');
            if (this.resetWhenGeneratingNewRecord) {
              self.$refs.UCWorkersComponent.Clear({
                autoFocus: true,
              });
            }
          } else {
            HiNotification.Alert('Comprueba los datos y prueba de nuevo.', 'El marcaje no se pudo realizar');
          }
          HiDialog.Preloader(false);
        }).catch((error) => {
          LogError(this, this.Conection_MakeNewRecordWorker.name, error);
          HiNotification.Toast(error);
          HiDialog.Preloader(false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.main-new-worker-record {
  margin-bottom: 25vh;
}
</style>
